import React from "react";
import Modal from "@material-ui/core/Modal";

import "./FarmMapDeleteConfirmModal.css";

function FarmMapDeleteConfirmModal({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading = false,
}) {
  return (
    <Modal open={open} onClose={onCancel} aria-labelledby="farm-map-delete-title">
      <div
        className="farm-map-delete-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="farm-map-delete-title">{title}</h2>
        <p>{message}</p>
        <div className="farm-map-delete-modal__actions">
          <button
            type="button"
            className="btn btn-default"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={loading}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default FarmMapDeleteConfirmModal;
